import { FC, SVGProps } from 'react';

export const CheckboxIconOn: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
		<rect x="0.5" y="0.5" width="17" height="17" rx="3.5" fill="white" stroke="white" strokeOpacity="0.2"/>
		<path d="M5 9L8 12L14 6" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
);
